import { createContext, useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

import { useAuth } from "@/hooks/use-auth";

const URL = import.meta.env.VITE_SOCKETS_URL;

export const SocketContext = createContext({
  socket: null,
  isSocketAlive: false,
  createSocketConnection: () => { },
});

export default function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const [isSocketAlive, setIsSocketAlive] = useState(false);

  const { isAuthenticated, astrologer } = useAuth();

  // TODO: Remove useEffect after adding Go Live Button to Astrologer
  useEffect(() => {
    if (isAuthenticated.loaded && isAuthenticated.status)
      createSocketConnection(astrologer.astrologerId);
  }, [isAuthenticated.status]);

  const createSocketConnection = (astrologerId) => {
    // Close existing connection if any
    if (socketRef.current) {
      socketRef.current.disconnect();
    }
    
    console.log(`[Socket] Creating connection for astrologer: ${astrologerId}`);
    
    const socket = io(URL, {
      query: { astrologerId }, 
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      timeout: 20000,
      forceNew: true // Force new connection
    });

    socket.on('connect', () => {
      console.log(`[Socket] Connected with ID: ${socket.id}`);
      setIsSocketAlive(true);
    });

    socket.on('disconnect', (reason) => {
      console.log(`[Socket] Disconnected: ${reason}`);
      setIsSocketAlive(false);
    });
    
    socket.on('connect_error', (error) => {
      console.error(`[Socket] Connection error:`, error);
      setIsSocketAlive(false);
    });

    // Store socket reference immediately
    socketRef.current = socket;
  };

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current ?? null,
        isSocketAlive,
        createSocketConnection,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
}
